import videojs from "video.js";
import "video.js/dist/video-js.css";
import "@videojs/http-streaming";

$(function () {

    let keydownHandler;

    // / Main function to handle video playback
    $(document).on("click", ".detail-play-button", async function () {
        const videoId = $(this).attr("video-id");
        if (!videoId) {
            swal("Requested video not Found!", { icon: "error" });
            return;
        }

        const existingPlayer = videojs.getPlayer('floating-video');
        if (existingPlayer) {
            existingPlayer.dispose();
            $(document).find(".floating-video").remove(); 
        }

        if (document.pictureInPictureElement) {
            document.exitPictureInPicture();
        }
        
        $("body").append(_views.controls.VIDEO_PLAYER);

        // Initialize draggable with playback state tracking
        const container = $("#floating-video-container");
        _video.setupDraggablePlayer(container);

        try {
            const response = await $.ajax({
                url: `/core/common/getVideoSignedUrl/${videoId}`,
                method: "GET",
                dataType: "json"
            });
        
            if (!response?.Data) {
                swal("Error fetching video URL!", { icon: "error" });
                console.error("Error fetching video URL: No data returned.");
                return;
            }
        
            const videoUrl = response.Data;
        
            $(document).find(".floating-video").removeClass("d-none").addClass("show");
        
            const player = _video.initializePlayer(videoUrl);
            player.ready(function () {
                $(".vjs-playback.forward, .vjs-playback.rewind").remove();
                _video.addPipButton(player);
                _video.handleFullscreenChange(player);
                keydownHandler = _video.setupKeyboardShortcuts(player);
                _video.setupFocusHandlers(player);
                _video.handleCloseButton(player, keydownHandler);
            });
        
            player.play();
        
        } catch (err) {
            swal("Error", err.responseJSON?.Message ?? "Something went wrong while loading the video.", "error");
        }
        
    });
});

const _video = {};

// Initialize Video.js player
_video.initializePlayer = function(videoUrl) {
    let existingPlayer = videojs.players["floating-video-container"];
    if (existingPlayer) {
        existingPlayer.dispose();
    }

    const player = videojs("floating-video", {
        techOrder: ["html5"],
        controls: true,
        autoplay: true,
        userActions: {
            click: false
          },
        preload: "auto",
        playbackRates: [0.5, 1, 1.5, 2],
        controlBar: {
            children: [
                "rewindButton",
                "playToggle",
                "forwardButton",
                "volumePanel",
                "progressControl",
                "currentTimeDisplay",
                "timeDivider",
                "durationDisplay",
                "playbackRateMenuButton",
                "fullscreenToggle"
            ]
        },
        sources: [{ src: videoUrl, type: "video/mp4" }]
    });

    return player;
}

//draggable video-container handling
_video.setupDraggablePlayer = function(container) {
    let wasPlayingBeforeDrag = true;

    container.draggable({
        handle: "#floating-video",
        containment: "window",
        scroll: false,
        start: function () {
            const player = videojs.getPlayer('floating-video');
            if (player) {
                wasPlayingBeforeDrag = !player.paused();
                player.userActive(false);
                player.pause(); // pause immediately on drag start
            }
            $(this).addClass('dragging');
        },
        stop: function () {
            $(this).removeClass('dragging');
            const player = videojs.getPlayer('floating-video');
            if (player) {
                player.userActive(true);
                if (player.paused() && wasPlayingBeforeDrag) {
                    player.play();
                } else {
                    player.pause(); // ✅ pause again after drag stops
                }
            }
        }
    });

    container.on('mousedown', '.vjs-control-bar, .close-video-btn', function (e) {
        container.draggable('disable');
        $(document).one('mouseup', function () {
            container.draggable('enable');
        });
        e.stopPropagation();
    });
}


// Add Picture-in-Picture button
_video.addPipButton = function(player) {
    if (document.pictureInPictureEnabled) {
        const controlBar = player.getChild("controlBar");

        // Avoid duplicate PiP buttons
        if (controlBar.getChild("PipButton")) return;

        const Button = videojs.getComponent("Button");

        class PipButton extends Button {
            constructor(player, options) {
                super(player, options);
                this.controlText("Picture-in-Picture");
                this.addClass("vjs-pip-button");
            }

            handleClick() {
                const videoElement = this.player().tech().el();
                if (!document.pictureInPictureElement) {
                    videoElement.requestPictureInPicture();
                    $(player.el()).closest(".floating-video").find(".close-video-btn").hide();
                    player.el().focus();
                } else {
                    document.exitPictureInPicture();
                    $(player.el()).closest(".floating-video").find(".close-video-btn").show();
                }
            }
        }

        videojs.registerComponent("PipButton", PipButton);
        controlBar.addChild("PipButton", {}, controlBar.children().length - 2);
    }
};

// Add custom rewind and forward buttons in fullscreen mode
_video.addCustomButtons = function(player) {
    $(player.el()).find(".vjs-playback.forward, .vjs-playback.rewind").remove();
    class RewindButton extends videojs.getComponent("Button") {
        constructor(player, options) {
            super(player, options);
            this.controlText("Rewind 10s");
            this.addClass("vjs-playback");
            this.addClass("rewind");
        }

        handleClick() {
            const currentTime = this.player().currentTime();
            this.player().currentTime(Math.max(0, currentTime - 10));
            player.el().focus();
        }
    }

    class ForwardButton extends videojs.getComponent("Button") {
        constructor(player, options) {
            super(player, options);
            this.controlText("Forward 10s");
            this.addClass("vjs-playback");
            this.addClass("forward");
        }

        handleClick() {
            const currentTime = this.player().currentTime();
            this.player().currentTime(currentTime + 10);
            player.el().focus();
        }
    }

    videojs.registerComponent("RewindButton", RewindButton);
    videojs.registerComponent("ForwardButton", ForwardButton);

    const controlBar = player.getChild("controlBar");
    const playButton = controlBar.getChild("playToggle");

    if (playButton) {
        controlBar.el().insertBefore(new RewindButton(player).el(), playButton.el());
        controlBar.el().insertBefore(new ForwardButton(player).el(), playButton.el().nextSibling);
    }
}

// Handle fullscreen change events
_video.handleFullscreenChange = function(player) {
    const container = $("#floating-video-container");

    player.on("fullscreenchange", function () {
        const isFullscreen = player.isFullscreen();

        if (isFullscreen) {
            _video.addCustomButtons(player);
            player.userActive(true);
            player.options_.userActions.click = true; 
            container.draggable("disable");
            container.addClass("fullscreen-mode");
        } else {
            $(player.el()).find(".vjs-playback.forward, .vjs-playback.rewind").remove();
            player.options_.userActions.click = false; 
            container.draggable("enable");
            container.removeClass("fullscreen-mode");  
        }

        player.el().focus();
    });
};


// Handle keyboard shortcuts
_video.setupKeyboardShortcuts = function(player) {
    let lastToggleTime = 0; 

    const keydownHandler = function(e) {
        const isFloatingVisible = $(player.el()).closest('.floating-video').hasClass("show");
        const isFullscreen = document.fullscreenElement || player.isFullscreen();

        if (isFloatingVisible && isFullscreen) {
            if (e.key === "ArrowLeft") {
                e.preventDefault();
                player.currentTime(Math.max(0, player.currentTime() - 10));
            } else if (e.key === "ArrowRight") {
                e.preventDefault();
                player.currentTime(player.currentTime() + 10);
            } else if (e.key === " ") {
                e.preventDefault();

                const now = Date.now();
                if (now - lastToggleTime > 300) {
                    if (player.paused()) {
                        player.play().catch(err => {
                            console.warn("Error playing video:", err);
                        });
                    } else {
                        player.pause();
                    }
                    lastToggleTime = now;
                }
            }
        }
    };

    // Remove any previous handlers to avoid multiple bindings
    $(document).off("keydown.videoShortcuts").on("keydown.videoShortcuts", keydownHandler);

    return keydownHandler;
};

//handle close video
_video.handleCloseButton = function (player, keydownHandler) {
    // Remove previous event handlers before adding a new one
    $(document).off("click", ".close-video-btn").on("click", ".close-video-btn", function () {

        if (document.pictureInPictureElement) {
            document.exitPictureInPicture();
        }

        if (keydownHandler) {
            $(document).off("keydown", keydownHandler);
        }

        ["PipButton", "rewindButton", "forwardButton"].forEach(button => {
            const existingBtn = player?.getChild("controlBar")?.getChild(button);
            if (existingBtn) {
                existingBtn.dispose();
            }
        });

        $(player?.el()).find(".vjs-playback.forward, .vjs-playback.rewind").remove();
        
        setTimeout(() => {
            if (player) {
                player.pause();
                player.dispose(); // Dispose of the player properly
            }
            $(document).find('.floating-video').prev('.modal-backdrop').remove();
            $(document).find('.floating-video').remove();
        }, 300);

    });
};

// Handle focus on play, pause, and fullscreen change
_video.setupFocusHandlers = function(player) {
    const videoElement = player.tech().el();

    player.on('play', function () {
        player.el().focus(); // Focus on the video element
    });

    player.on('pause', function () {
        player.el().focus(); // Focus on the video element
    });

    player.on('fullscreenchange', function () {
        player.el().focus(); // Focus on the video element
    });

    // Show close button when exiting PiP mode
    videoElement.addEventListener('leavepictureinpicture', function () {
        $(player.el()).closest('.floating-video').find('.close-video-btn').show();
    });
}